import { render, staticRenderFns } from "./CalendarDialog.vue?vue&type=template&id=5addf7e0&"
import script from "./CalendarDialog.vue?vue&type=script&lang=js&"
export * from "./CalendarDialog.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports